import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/mergeMap';
import type { ActionsObservable, Epic } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import {
	DELETE_COMPONENT_CONFIRMATION,
	DELETE_COMPONENT_SUCCESS,
	DELETE_COMPONENT_FAIL,
	CANCEL,
	type DeleteComponentFailAction,
} from '../state/actions/delete.tsx';
import type { Action } from '../state/actions/types.tsx';
import {
	onDialogDisplay,
	onSuccessful,
	onFail,
	onDialogCancel,
} from '../state/selectors/callbacks.tsx';
import { isDialogOpen } from '../state/selectors/modal.tsx';
import type { State } from '../state/types.tsx';

// dialog is displayed
export const dialogDisplayed: Epic<Action, State> = (
	action$: ActionsObservable<Action>,
	store: MiddlewareAPI<State>,
) =>
	action$.ofType(DELETE_COMPONENT_CONFIRMATION).mergeMap(() => {
		onDialogDisplay(store.getState())();
		return Observable.empty<never>();
	});

// delete finished
export const componentDeleted: Epic<Action, State> = (
	action$: ActionsObservable<Action>,
	store: MiddlewareAPI<State>,
) =>
	action$.ofType(DELETE_COMPONENT_SUCCESS).mergeMap(() => {
		onSuccessful(store.getState())();
		return Observable.empty<never>();
	});

// failure
export const failure: Epic<Action, State> = (
	action$: ActionsObservable<Action>,
	store: MiddlewareAPI<State>,
) =>
	action$.ofType(DELETE_COMPONENT_FAIL).mergeMap((action: DeleteComponentFailAction) => {
		const {
			payload: { error },
		} = action;
		const state = store.getState();
		onFail(state)(error, isDialogOpen(state));
		return Observable.empty<never>();
	});

// cancel
export const cancel: Epic<Action, State> = (
	action$: ActionsObservable<Action>,
	store: MiddlewareAPI<State>,
) =>
	action$.ofType(CANCEL).mergeMap(() => {
		onDialogCancel(store.getState())();
		return Observable.empty<never>();
	});
